import React from 'react';
import PropTypes from 'prop-types';
import { GAMES_CATEGORY_PAGE } from 'core/constants';
import { CategoryGames } from 'components/category-games/category-games';
import { HeadHelmet } from 'components/head-helmet/head-helmet';

import { PAGE_NAMES } from '../../constants';

import './category.scss';

export const CategoryUI = ({ match: { params: { id: category } } }) => (
  <>
    <HeadHelmet
      page={PAGE_NAMES.CATEGORY}
      values={{ category }}
      options={{
        indexing: category !== GAMES_CATEGORY_PAGE.RECENTLY_PLAYED,
      }}
    />

    <CategoryGames
      coreProps={{ category }}
    />
  </>
);

CategoryUI.propTypes = {
  match: PropTypes.shape().isRequired,
};

export default CategoryUI;
